import Vue from 'vue';
import moment from 'moment';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'StoreRequisition',
  components: {
    TimeComp: require('../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        applicationId: -1,
        id: 0,
        reqDateTime: new Date(),
        takenQuantity: 0,
        usedQuantity: 0,
        sourceWareHouseId: 0,
        destinationWareHouseId: 0,
        readonly: false,
        itemId: -1,
        itemsInventory: [],
        item: { id: 0, name: '' },
      },
      emptyItem: '',
      showDate: { reqDateTime: false },
      reqTime: { hours: 0, minutes: 0, descr: 'storeRequisition.ReqTime', isReadOnly: false },
      reqDateTime: {},
    }
  },
  computed: {
    formattedReqDateTime: function () {
      return this.formatDateUI(moment(this.reqDateTime));
    },
    ReqTimeHours: function () {
      return this.reqTime.hours;
    },
    ReqTimeMinutes: function () {
      return this.reqTime.minutes;
    },
    item: function () {
      return this.appData.item;
    },
  },
  watch: {
    ReqTimeHours: function (value) {
      this.appData.ReqTimeHours = value;
    },
    ReqTimeMinutes: function (value) {
      this.appData.ReqTimeMinutes = value;
    },
    item: function (value) {
      this.appData.itemId = value ? value.id : -1;
      this.$refs.select.open = false;
    },
    emptyItem: function (value) {
      this.appData.itemId = value ? value.id : -1;
      this.$refs.select.open = false;
    },
  },
  created() {
    this.$root.$on('store_requisition_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appData = this.dataObj;
        this.value = this.appData.itemName;
        var item = this.appData.itemsInventory.filter(inv => inv.id == this.appData.itemId)[0];

        this.appData.item = (item ? item : this.appData.item);

        //this.reqDateTime = moment(this.appData.reqDateTime).subtract(1, 'days').format();
        this.reqTime.hours = this.appData.ReqTimeHours;
        this.reqTime.minutes = this.appData.ReqTimeMinutes;
      });
    },
    getInventorySet(itemName) {
      var res = (itemName.length == 0) ? this.appData.itemsInventory : this.appData.itemsInventory.filter(item => item.name.indexOf(itemName) == 0);
      return (res.length > 0) ? res : [];
    },
    getInventoryPromise(itemName) {
      return new Promise((resolve => {
        var res = (itemName.length == 0) ? this.appData.itemsInventory : this.appData.itemsInventory.filter(item => item.name.toUpperCase().indexOf(itemName.toUpperCase()) > -1);
        return (res.length > 0) ? resolve(res) : resolve([]);
      }));
    },
    fetchInventory(param) {
      return this.getInventoryPromise(param.q);
    },
    inventorySelected(item) {
      this.appData.item = item;
      this.appData.itemId = item.id;
    },
  },
}